import React from 'react';
import { motion } from 'framer-motion';
import { PrimaryButton } from './PrimaryButton';
import { RangeSlider } from './RangeSlider';
import { FollicleCluster } from './FollicleCluster';
import { AMH_RANGE, WEIGHT_RANGE, responseTendency, zoneFor, zoneLabels } from '../../utils/responseTendency';
type MiniSimScreenProps = {
  amh: number;
  weight: number;
  onAmh: (v: number) => void;
  onWeight: (v: number) => void;
  onNext: () => void;
};
export function MiniSimScreen({
  amh,
  weight,
  onAmh,
  onWeight,
  onNext
}: MiniSimScreenProps) {
  const position = responseTendency(amh, weight);
  const zone = zoneFor(position);
  return <div className="flex h-full flex-col" data-id="element-117" data-mp="3kx0qfxco522x">
      <h2 className="text-[30px] font-semibold leading-[1.04] tracking-[-0.035em] text-ink" data-id="element-118" data-mp="3px5atygp6gyf">
        Change the patient.
        <br data-id="element-119" data-mp="108watn985nef" />
        See the challenge.
      </h2>

      <div className="mt-5" aria-live="polite" data-id="element-120" data-mp="10ah29408sq82">
        <FollicleCluster position={position} zone={zone} data-id="element-121" data-mp="1564rfjeq5jdk" />
        <div className="relative mt-3 h-4" data-id="element-122" data-mp="at2nr96o66j6">
          <div className="absolute inset-x-0 top-1/2 flex h-[4px] -translate-y-1/2 overflow-hidden rounded-full" data-id="element-123" data-mp="as1cp4pnlk1g">
            <span className="flex-1 bg-ink/10" data-id="element-124" data-mp="6rz9us86mkkl" />
            <span className="w-[32%] bg-accent/70" data-id="element-125" data-mp="1s4hek8rdmxf" />
            <span className="flex-1 bg-ink/10" data-id="element-126" data-mp="1qtesnr1ul7w" />
          </div>
          <motion.span className="absolute top-1/2 h-4 w-4 -translate-x-1/2 -translate-y-1/2 rounded-full border-2 border-white bg-ink shadow-[0_1px_4px_rgba(28,29,34,0.3)]" animate={{
          left: `${position * 100}%`
        }} transition={{
          duration: 0.2,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-127" data-mp="3szh1b7110eh1" />
        </div>
        <div className="mt-2 grid grid-cols-3 font-mono text-[9px] leading-tight tracking-[0.08em] text-graphite" data-id="element-128" data-mp="3f7sn8y77vfxf">
          <span data-id="element-129" data-mp="3a63ddlvqd8ax">← LOWER</span>
          <span className="text-center text-accent" data-id="element-130" data-mp="358tp49k2v2oo">TARGET ZONE</span>
          <span className="text-right" data-id="element-131" data-mp="35b7hubrac2t2">HIGHER →</span>
        </div>
        <p className={`mt-3 text-center text-[15px] font-semibold tracking-[-0.01em] ${zone === 'target' ? 'text-accent' : 'text-ink'}`} data-id="element-132" data-mp="30bbfegy8kjfm">
          {zoneLabels[zone]}
        </p>
      </div>

      <div className="mt-4 space-y-2" data-id="element-133" data-mp="2vmiop09g8p46">
        <RangeSlider label="AMH" unit="pmol/L" min={AMH_RANGE.min} max={AMH_RANGE.max} value={amh} onChange={onAmh} data-id="element-134" data-mp="2vjeffoh4n36n" />
        <RangeSlider label="BODY WEIGHT" unit="kg" min={WEIGHT_RANGE.min} max={WEIGHT_RANGE.max} value={weight} onChange={onWeight} data-id="element-135" data-mp="2lnbf8o5u5emc" />
      </div>
      <p className="mt-2 text-[11px] leading-snug text-graphite" data-id="element-136" data-mp="39e7174nm1flo">
        AMH drives expected responsiveness most. Body weight shapes the dose, not the response on its own.
      </p>

      <div className="mt-auto pt-4" data-id="element-137" data-mp="30ldisycva03l">
        <PrimaryButton onClick={onNext} data-id="element-138" data-mp="30kbwfxqehr6k">SEE THE REKOVELLE APPROACH</PrimaryButton>
      </div>
    </div>;
}